import React from "react";
import PicturesShell from "../PicturesShell";
import "./style.css";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Pictures app error:", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <PicturesShell mainClassName="pi-pictures-main--center">
          <div className="pi-pictures-status-card pi-error-boundary">
            <span className="pi-pictures-label">Photo upload</span>
            <h1>Something went wrong</h1>
            <p>Please refresh the page and open your photo link again.</p>
          </div>
        </PicturesShell>
      );
    }

    return this.props.children;
  }
}
